import events from 'lib/events';
import Instructions from './Instructions';
import IntlWrapper from 'components/layout/intlWrapper';
import Page from './Report';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import toolFlow from 'helpers/toolFlow';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {Header} from 'components/layout';

// Register in router
let render = (container, params) => {
  console.info('[UI.page.tools.accounts.multiple-systems] rendering page');
  ReactDOM.render(<IntlWrapper><MultipleSystems page={params.page || 0} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools.acounts.multiple-systems] register route');
router.rr.add([{path: 'tools/accounts/multiple-systems/:page', handler: routeUtils.requireAuth(render)}]);

class Wrapper extends React.Component {
  static propTypes = {
    View: PropTypes.any.isRequired,
    intl: intlShape.isRequired,
  };

  state = {};

  render() {
    let {View} = this.props;
    let {formatMessage} = this.props.intl;

    return <div className='container'>
      <Header subTitle={formatMessage({id: 'tools.find.multiple.systems'})}
              mainTitle={formatMessage({id: 'general.accounts'})}
              mainTitleReturn='#tools/accounts' />
      <View />
    </div>;
  }
}

const MultipleSystems = injectIntl(toolFlow(Wrapper, Instructions, Page));
